export const SIZE_ORDER = {
  "XS": 1,
  "S": 2,
  "M": 3,
  "L": 4,
  "XL": 5,
  "XXL": 6,
  "XXXL": 7,
};

export function sortBySize<T extends { size: string | number }>(list: T[]) {
  return list.sort((a, b) => {
    const rawSizeA = a.size;
    const rawSizeB = b.size;

    const numericSizeA = toNumericSize(rawSizeA);
    const numericSizeB = toNumericSize(rawSizeB);

    if (numericSizeA !== null && numericSizeB !== null) {
      return numericSizeA - numericSizeB;
    }

    const sizeA = normalizeSize(rawSizeA);
    const sizeB = normalizeSize(rawSizeB);

    // Если оба размера есть в нашем порядке
    if (SIZE_ORDER[sizeA] && SIZE_ORDER[sizeB]) {
      return SIZE_ORDER[sizeA] - SIZE_ORDER[sizeB];
    }

    // Если один из размеров нестандартный(2XL, 3XL, 4XL), используем числовую логику
    const numA = extractNumberFromSize(sizeA);
    const numB = extractNumberFromSize(sizeB);

    if (numA !== null && numB !== null) {
      return numA - numB;
    }

    // Если один размер стандартный, а другой - числовой XL
    if (SIZE_ORDER[sizeA] && numB !== null) {
      return SIZE_ORDER[sizeA] - (numB + 4);
    }

    if (numA !== null && SIZE_ORDER[sizeB]) {
      return numA + 4 - SIZE_ORDER[sizeB];
    }

    return sizeA.localeCompare(sizeB);
  });
}

// функция для извлечения числа из размеров типа 2XL, 3XL и т.д.
function extractNumberFromSize(size: string) {
  const match = size.match(/^(\d+)XL$/i);
  return match ? parseInt(match[1]) : null;
}

// функция для преобразования размера в число, если это возможно
function toNumericSize(value: string | number) {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

// функция для нормализации размера
function normalizeSize(size: string | number) {
  return typeof size === "string" ? size.toUpperCase() : String(size);
}
